import ReactDOM from "react-dom/client";
import React from "react";
import App from "./App";
import "@mantine/core/styles.css";
import "@mantine/carousel/styles.css";
import "@mantine/dates/styles.css";
import "@mantine/charts/styles.css";
import "mantine-react-table/styles.css";
import "@mantine/dropzone/styles.css";
import "@gfazioli/mantine-marquee/styles.css";
import "@gfazioli/mantine-marquee/styles.layer.css";

import "react-international-phone/style.css";
import "./index.css";
import { Provider } from "jotai";

if (process.env.NODE_ENV === "development") {
  const React = require("react");
  const whyDidYouRender = require("@welldone-software/why-did-you-render");

  whyDidYouRender(React, {
    trackAllPureComponents: false,
    include: [/AreaChartComp/, /CustomAreaChart/], // sadece bizimkiler
    exclude: [/^(Legend|Tooltip|TooltipBoundingBox)$/, /recharts/i, /Mantine/i],
    collapseGroups: true,
  });
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <Provider>
    <App />
  </Provider>
);
